import React, { useState, useEffect } from "react"
import "./EditManageStaff.scss"
import { useHistory, useLocation } from "react-router"
import { useSelector } from "react-redux"
import Button from "../../../../components/Button"
import Dropdown from "components/DropDown"
import moment from 'moment'
import { getAllCenters, getAvailabilityDetails, getManageStaffDetailsById, updateAvailability } from "core/services/api"
import { MocUserRole } from "core/services/models/Enums"
import Toast from "components/Toast"

export default function StaffAvailability() {
  const history = useHistory()
  const location: any = useLocation()
  const id = location?.state?.idValue
  let readOnly = useSelector((state: any) => state?.user?.readOnly);
  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  const slotDuration: string[] = [
    "Morning Slot",
    "Afternoon Slot",
    "Evening Slot",
  ]




  const [staffDetails, setStaffDetails] = useState<any>({})
  const [allCenterDetails, setAllCenterDetails] = useState<any>([])
  const [staffCenterOptions, setStaffCenterOptions] = useState<any>([])
  const [selectedCenterDetails, setSelectedCenterDetails] = useState<any>({})
  const [allowed, setAllowed] = useState<any>([])
  //const [availabilitySlots, setAvailabilitySlots] = useState<any>(slots)
  const [avaialbilityResult, setAvaialbilityResult] = useState<any>()
  const [hours, setHours] = useState('01')
  const [minutes, setMinutes] = useState('00')
  const [ampm, setAMPM] = useState('am')
  const [absenseListInfo, setAbsenseListInfo] = useState<any>({
    fromTime: "",
    toTime: "",
    absenseFromDate: "",
    absenseFromTime: "",
    absenseToDate: "",
    absenseToTime: "",
    remarks: "",
  })
  const [slotsRequired, setSlotsRequired] = useState<any>()
  const [success, setSuccess] = useState<boolean>(false)
  const [message, setMessage] = useState<string>("")
  const [toastType, setToastType] = useState<string>("")
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [displayToast, toggleDisplayToast] = useState<any>(false)

  useEffect(() => {
    console.log("inside Staff Unavailability Page");
    getAllCenterDetails()
    getStaffDetails()
    updateCenterDetails()
  }, [])

  useEffect(() => {
    getSlotDuration()
    fetchAvailabilityDetails()
  }, [selectedCenterDetails, staffDetails])

  const getStaffDetails = () => {
    if (id) {
      getManageStaffDetailsById(id)
        .then((res: any) => {
          const centersOptions = res?.centers?.map((each: any) => each?.centerName)
          const temp = res?.secondaryRoles?.map((ele: any) => ele)
          temp.push(res?.primaryRole)
          setAllowed(Array.isArray(temp) && temp?.length > 0 ? temp : [])
          setStaffCenterOptions(centersOptions)
          setStaffDetails(res)
        })
        .catch((err: any) => {
          console.log("Err,", err)
        })
    }
  }

  const getAllCenterDetails = () => {
    getAllCenters()
      .then((res: any) => {
        setAllCenterDetails(res)
      })
      .catch((err: any) => {
        console.log("Err,", err)
      })
  }

  const updateCenterDetails = () => {
    if (userRole === MocUserRole?.CENTER_ADMIN) {
      if (userDetail?.currentCenter && Object.keys(userDetail?.currentCenter)?.length > 0) {
        const tempCenter: any = {
          ...userDetail?.currentCenter
        }
        tempCenter["id"] = tempCenter?.centerId
        delete tempCenter["centerId"]
        setSelectedCenterDetails(tempCenter)
      }
    }
  }



  const getSlotDuration = () => {
    if (userRole === MocUserRole.CENTER_ADMIN) {
      const temp = allCenterDetails.find((c: any) => c?.id === userDetail?.currentCenter?.centerId)
      if (temp) {
        setSlotsRequired(temp?.slotDuration)
      }
    }
    else if (userRole === MocUserRole.SYSTEM_ADMIN) {
      const temp = allCenterDetails.find((label: any) => label?.id === selectedCenterDetails?.centerId)
      if (temp) {
        setSlotsRequired(temp?.slotDuration)
      }
    }
  }

  const fetchAvailabilityDetails = () => {
    if (staffDetails?.id && selectedCenterDetails?.id) {
      let centerId = selectedCenterDetails?.id
      getAvailabilityDetails(
        centerId,
        staffDetails?.id
      )
        .then((res) => {
          console.log(res[0], "re")
          setAvaialbilityResult(res[0])
        })
        .catch((err) => {
          console.log("Err", err)
        })
    }
  }



  const handleUnblockCalendar = (id: any) => {
    avaialbilityResult.unavailability = avaialbilityResult?.unavailability?.filter((entry: any) => entry?.id != id)
    updateAvailability(avaialbilityResult)
      .then((res: any) => {
        setIsLoading(false)
        setMessage("Calendar has been unblocked successfully")
        setToastType("success")
        setSuccess(true)
        fetchAvailabilityDetails()
      })
      .catch((err: any) => {
        console.log(err, "error")
        setIsLoading(false)
        setMessage(err?.response?.data?.message)
        setSuccess(true)
        setToastType("error")
      })
  }






  return (
    <div className="edit-manage-staff-wrapper">
      {
        success ? (
          <Toast
            textMessage={message}
            onCloseText={"Close"}
            onClose={() => {
              setSuccess(false)
            }}
            type={toastType}
          ></Toast>
        ) : isLoading ? (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        ) : displayToast ? (
          <Toast
            textMessage={displayToast?.text}
            type={displayToast?.type}
            onClose={() => toggleDisplayToast(false)}
            onCloseText="Close"
            onClickText={null}
          />
        ) : null
      }

      {(userRole === MocUserRole.CONSULTANT ||
        userRole === MocUserRole.HOME_CARE_NURSE ||
        userRole === MocUserRole.HOME_CARE_RMO ||
        userRole === MocUserRole.GENETIC_COUNSELLOR ||
        userRole === MocUserRole.PHYSIOTHERAPIST ||
        userRole === MocUserRole.PSYCHOLOGIST) ?
        <div
          className="approval-back-image"
          onClick={() => {
            history.push({
              pathname: "/calendar",
            })
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
          <div className="edit-manage-staff-heading">Staff Unavailability Details</div>
        </div>

        : <div
          className="approval-back-image"
          onClick={() => {
            history.push({
              pathname: "/editManageStaff",
              state: { idValue: id },
            })
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
          <div className="edit-manage-staff-heading">Staff Unavailability Details</div>
        </div>
      }

      <div className="edit-details-wrapper">
        <div className="edit-details-container" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
          <div>
            {/* Location Select */}
            <div className="col-md-4 col-lg-4 staff_details">
              <div>
                <label className="edit-details-heading">Location : </label>
              </div>
              <Dropdown
                selected={selectedCenterDetails?.centerName}
                placeholder="Select Center"
                options={staffCenterOptions}
                updateDropdown={(option: any) => {
                  const centerObj = allCenterDetails?.find((c: any) => c?.centerName === option)
                  if (centerObj) {
                    console.log(centerObj, "centerObj")
                    setSelectedCenterDetails(centerObj)
                  }
                }}
                disable={readOnly || userRole === MocUserRole?.CENTER_ADMIN}
              />
            </div>
            <div>
              <div className="unavailability-table">
                <table>
                  <thead>
                    <tr>
                      <th>Reason</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {avaialbilityResult?.unavailability?.map((unavailability: any) => {
                      const endTime = moment(unavailability?.end);
                      const currentTime = moment();

                      // Check if the end time is greater than the current time
                      const isPastEvent = endTime.isBefore(currentTime);

                      return (
                        <tr key={unavailability?.id}>
                          <td>{unavailability?.reason || 'N/A'}</td>
                          <td>{moment(unavailability?.start).format("DD/MM/YYYY, h:mm:ss a")}</td>
                          <td>{moment(unavailability?.end).format("DD/MM/YYYY, h:mm:ss a")}</td>
                          <td>
                            {isPastEvent ? (
                              <span>Cannot unblock for previous date</span>
                            ) : (
                              <Button
                                text="Unblock Calendar"
                                type="submit"
                                disabled={!selectedCenterDetails?.id}
                                onClick={() => {
                                  handleUnblockCalendar(unavailability?.id);
                                }}
                                id="save"
                              />
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>


                </table>
              </div>


            </div>

          </div>
          {/* Page Actions */}
          {/* <div className="button-alignment">
            <div>
              <Button
                text="Cancel"
                  type={"button"}
                outline={true}
                disabled={readOnly}
                onClick={() => history.push({
                  pathname: "/editManageStaff",
                  state: { idValue: id },
                })}
                id="cancel"
              />
            </div>
            <div>
              <Button
                text={avaialbilityResult?.id ? "Update" : "Save"}
                type="submit"
                disabled={!selectedCenterDetails?.id}
                onClick={handleAvailability}
                id="save"
              />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}
